import React from 'react'
import { FaVideo } from 'react-icons/fa'
import { Box, Button, FileChooser, VideoViewer } from '@/components/lib'

export default function Video ({ dataType, value, onChange, participant }) {
  return (
    <Box>
      {!value?.fileName &&
        <FileChooser
          accept='video/*,.mp4,.mkv,.avi,.mov'
          fileType='video'
          forType='participant' forObject={participant}
          onComplete={({ storedName, name, expectedUrl }) => onChange({ name, fileName: storedName, needsVideoProcess: true, url: expectedUrl })}
          trigger={<Button size='sm' variant='outline' colorPalette='primary'><Box as={FaVideo} mr={2} /> Choose a file</Button>}
        />}
      {value?.url &&
        <VideoViewer url={value.url} thumbUrl={value.thumbUrl} onRemove={() => onChange('')} isProcessing={value.needsVideoProcess} hasError={value.processError} />}
    </Box>
  )
}
